import * as React from 'react';

import {Illustration} from '../illustrations/illustration';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import styles from './chat-preview.module.css';

export type EngagementFormType = 'Call' | 'Text' | 'Email' | 'Quote';

type Props = {
    formType: EngagementFormType;
    formDescription: string;
    formIcon?: React.ReactNode;
    shouldLinkItem: boolean | null | undefined;
    linkItem: string | null | undefined;
};

export function EngagementFormContent(props: Props) {
    return (
        <Stack spacing={12}>
            {props.shouldLinkItem && (
                <div className={styles['form-button']}>
                    <Stack
                        isHorizontal={true}
                        alignItems='center'
                        justifyContent='center'
                        spacing={4}
                    >
                        {props.formIcon}
                        <Body size='mini'>{props.formType}</Body>
                        <Body size='mini'>{props.linkItem}</Body>
                    </Stack>
                </div>
            )}
            <div className={styles['offline-form-container']}>
                <Illustration src='form-fields' width='100%' height='100%' />
                <Body size='small' isBold={true}>
                    {props.formDescription}
                </Body>
                <Body size='mini'>Customize your form before attaching it</Body>
            </div>
        </Stack>
    );
}
